import { ISessionCrew } from '@/types/session.types';
import { Post } from '../helpers';

const UpdateSessionCrewAssociations = ({
  sessionUuid,
  addedCrewAdminIds,
  removedCrewAdminIds,
}: {
  sessionUuid: string;
  addedCrewAdminIds: number[];
  removedCrewAdminIds: number[];
}): Promise<ISessionCrew[]> => {
  return Post({
    url: `/v3/admin/events/session/crew/${sessionUuid}`,
    body: { addedCrewAdminIds, removedCrewAdminIds },
  });
};

export default UpdateSessionCrewAssociations;
